import clsx from 'clsx'
import type { ReactNode } from 'react'

type Width = 'content' | 'wide' | 'full'

const widthStyles: { [key in Width]: string } = {
  content: 'max-w-3xl lg:max-w-4xl',
  wide: 'max-w-5xl',
  full: 'max-w-none',
}

interface Props {
  children: ReactNode
  className?: string
  width?: Width
}

const AdminPage = ({ children, className, width = 'full' }: Props) => {
  return (
    <div
      className={clsx(
        'px-5 pb-16 pt-4 sm:px-6 md:px-8 md:pb-16 md:pt-5 lg:px-10',
        widthStyles[width],
        className,
      )}
    >
      {children}
    </div>
  )
}

export default AdminPage
